import React from "react";
import getSize from "../../../../utils/getSize";
import NHTable from '../../../common/NHTable';
import css from './index.css';
import {hasAuth} from "../../../../utils/NHCore";
import { message, Button, Table, Select, Input } from 'antd';

/**
 * 军训服装查询
 * @author sujunming
 * @date 2018-07-03 15:45:03
 * Version: 1.0
 */
class JxfzIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }


    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('军训服装信息');
    }


    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '服装尺码',
                width: '100px',
                dataIndex: 'FZCMMC',
                searchType:"select"
            }, {
                title: '鞋码',
                width: '100px',
                dataIndex: 'XMCMMC',
                searchType:"input"
            }, {
                title: '身高',
                width: '100px',
                dataIndex: 'SG',
                searchType:"input"
            }, {
                title: '体重',
                width: '100px',
                dataIndex: 'TZ',
                searchType:"input"
            }, {
                title: '备注',
                width: '100px',
                dataIndex: 'BZ',
                searchType:"input"
            },{
                title: '办理时间',
                width: '100px',
                dataIndex: 'BLSJ',
                commonsearch: false,
                searchType:"date"
            }
        ];
        
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div style={{ width: '100%', height: '97%', }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_scjtJxfzcx_queryPage"}
                        columns={columnConst}
                        rangeFilter={true}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_jxfzcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                    </NHTable>

                </div>
            </div>
        )
    }
}
export default JxfzIndex;



// WEBPACK FOOTER //
// ./components/tjcx/jxfzcx/scjtJxfzcx/index.js